const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const SensorPeripheral = require('../common/sensor-peripheral');
const { default: bleUtils } = require('../../util/ble');
const { BLE_CONFIG } = require('../../util/bleCharac');


/**
 * 高精无线温度传感器
 * 
 * @readonly
 */
const DIVECE_OPT = {
    type: 'sensor'
};

// const BLE_CONFIG = {
//     prefix: 'LM',
//     SERVICE_UUID: 0x02FF,
//     temperature: 0x0302,
// }
/**
 * Manage communication with a Arduino esp32 peripheral over a Scratch Link client socket.
 */
class YMTH1P extends SensorPeripheral {
    /**
     * Construct a Arduino communication object.
     * @param {Runtime} runtime - the Scratch runtime
     * @param {string} deviceId - the id of the extension
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, deviceId, originalDeviceId) {
        super(runtime, deviceId, originalDeviceId, null, BLE_CONFIG, DIVECE_OPT);
    }
}

class ScratchYMTH1PDevice {

    /**
     * @return {string} - the ID of this deivce.
     */
    get DEVICE_ID() {
        return 'yiThermeterA';
    }

    /**
     * Construct a set of Arduino blocks.
     * @param {Runtime} runtime - the Scratch runtime.
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, originalDeviceId) {
        /**
         * The Scratch runtime.
         * @type {Runtime}
         */
        this.runtime = runtime;

        
        this._peripheral = new YMTH1P(this.runtime, this.DEVICE_ID, originalDeviceId);
        this.bleUtils = new bleUtils();
    }

    getInfo() {
        return [{
            id: 'yiThermeterA',
            name: formatMessage({
                id: 'YMTH1P.categoryName',
                default: 'YM TH1',
                description: 'Label for the YM TH1 extension category'
            }),
            color1: "#4CAF50",
            color2: "#47A94A",
            color3: "#429E44",
            blocks: [
                {
                    opcode: 'connect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMTH1P.ble.connect',
                        default: 'connect to YM-TH1-[DEVICE_NAME]',
                        description: 'Connect to YM-TH1'
                    }),
                    arguments: {
                        DEVICE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        }
                    }
                },
                {
                    opcode: 'disConnect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMTH1P.ble.disconnect',
                        default: 'disconnect from YM-TH1',
                        description: 'Disconnect from YM-TH1'
                    })
                },
                {
                    opcode: 'getTemperature',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMTH1P.getTemperature',
                        default: 'get temperature',
                        description: 'Get the temperature of the light'
                    })
                }
            ],
            menus: {}
        }];
    }

    async connect(args) {
        const deviceName = 'YM-TH1-' + (args.DEVICE_NAME?.trim() || "");
        const connected = await this.isConnected();
        if (connected) {
            console.log('Already connected to device');
            return;
        }
        console.log(`Connecting to YM-TH1 device: ${deviceName}`);
        try {
            await this.bleUtils.connect(deviceName, BLE_CONFIG.SERVICE_UUID);
            console.log(`Connected to device: ${deviceName}`);

        } catch (error) {
            console.error(`Failed to connect to ${deviceName}:`, error);
        }
    }

    async isConnected() {
        console.log('Checking if device is connected');
        return this.bleUtils.device !== null && this.bleUtils.device.gatt.connected;
    }

    async disConnect() {
        console.log('Disconnecting from YM-TH1 device');
        if (this.bleUtils.device) {
            try {
                await this.bleUtils.disConnect(this.bleUtils.device);
                console.log('Disconnected from device');
            } catch (error) {
                console.error('Failed to disconnect:', error);
            }
        }
    }

    async getTemperature() {
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.temperature);
                const dataView = await this.bleUtils.readCharacteristic(characteristic);
                if (dataView?.buffer instanceof ArrayBuffer) {
                    //解析数据
                    let buffer = Array.from(new Uint8Array(dataView.buffer));
                    const hexStr = buffer.map(_ => {
                        return this.bleUtils.int2Hex(_);
                    }).reverse().join("");
                    const temperature = this.bleUtils.hex2float(hexStr, 2, 4);
                    console.log(`temperature: ${temperature}`);
                    // 设置精灵坐标
                    // this.runtime.targets.forEach(target => {
                    //     if (target.isSprite) {
                    //         // 设置x和y坐标
                    //         target.setXY(temperature, target.y);
                    //     }
                    // });
                    return temperature;
                }
            } catch (error) {
                console.error('Failed to set temperature:', error);
            }
        }
    }
}

module.exports = ScratchYMTH1PDevice;